import Vue from "vue";
import axios from "axios";
import { extractDnsMxRecords } from "../utility/dns/extractDnsMxRecords";
import * as Sentry from "@sentry/vue";

Vue.component('onboarding-mailer-setup', {
  data() {
    return {
      dns: null,
      dnsMx: null,
      name: null,
      verified: null,
      error: null,
      loading: true
    }
  },
  props: ['wizardEmailDefaultSubdomain'],
  methods: {
    submit() {
      let domain = document.getElementById('emailDomain').value;
      this.error = null;
      this.loading = true;

      axios.post('/api/?entity=vessel&action=mailerDomainSetup', {domain: domain}).then( (response) => {
        const {dns} = response.data && response.data.data || {};
        if( dns ) {
            window.location.href = "/vessel/register/dns?domain=" + dns[0].name;
        }else{
          this.loading = false;
        }
      }).catch(error => {
        const {data} = error.response || {};
        const message = data && (data.message || (data.data && data.data.message));
        if (message) {
          this.error = message;
        } else {
          Sentry.captureException(error);
        }
      });
    },
    verifyDNS() {
      this.loading = true;
      axios.get('/api/?entity=vessel&action=verifyDomainMailerConfig', {}).then( (response) => {

        if( typeof response.data.data !== 'undefined' &&
          typeof response.data.data.dns !== 'undefined' &&
          typeof response.data.data.verified !== 'undefined' &&
          typeof response.data.data.name !== 'undefined'
        ) {
          return response.data.data;
        }
        return false;

      }).then( (meta) => {

        if( meta ) {
          [this.verified, this.name] = [meta.verified, meta.name];
          this.dns = (meta.dns || []).filter(record => record.type !== 'MX');
          this.dnsMx = this.createDnsMxRecords(meta.dns);
          this.loading = false;
        }else{
          this.loading = false;
        }
      }).catch(error => {
        console.error(error);
        this.loading = false;
      });
    },
    createDnsMxRecords(records) {
      const mxRecords = extractDnsMxRecords(records);
      if (mxRecords && mxRecords.length > 0) {
        return mxRecords;
      }

      if(this.wizardEmailDefaultSubdomain == ''){
        this.theDomain = this.name;
      }else{
        this.theDomain = this.wizardEmailDefaultSubdomain;
      }

      return [
        {type: 'MX', name: this.theDomain, priority: '10', value: 'mxa.mailgun.org'},
        {type: 'MX', name: this.theDomain, priority: '10', value: 'mxb.mailgun.org'},
      ];
    },
    reload() {
      location.reload();
    }
  },
  mounted() {
    this.verifyDNS();
  }
});